export default (width = 1, height = 1) => {
  const targetWidth = 640;
  const coefficient = width / targetWidth;

  return {
    width: width / coefficient,
    height: height / coefficient,
  };
};
